import { GAMES, STRENGTHS } from '../../content'
import { SubRange } from '../../engine'
import { anim, prog, stagger } from '../../motion'
import { Phone, Shape } from '../../primitives'
import { GameScreens } from '../../scenes/SceneGames'
import { Fit } from '../kit'

// Das Smartphone richtet sich in 3D auf, dann laufen Einladung, Spiele und Feedback
const CAPTIONS = [
  {
    side: 'left',
    at: [0.24, 0.29],
    out: [0.39, 0.43],
    eyebrow: 'Codeknacker',
    text: 'Verhalten statt Selbstauskunft.'
  },
  {
    side: 'right',
    at: [0.44, 0.49],
    out: [0.58, 0.62],
    eyebrow: 'Gefühlschaos',
    text: 'Validierte Verfahren der Eignungsdiagnostik.'
  },
  {
    side: 'left',
    at: [0.63, 0.68],
    out: [0.78, 0.82],
    eyebrow: 'Dreamteam',
    text: 'Fähigkeiten, Persönlichkeit, Kultur, Interessen.'
  },
  {
    side: 'right',
    at: [0.84, 0.89],
    eyebrow: 'Direkt danach',
    text: 'Feedback sofort. Für alle.'
  }
]

const NARROW = { maxW: 0.7, maxH: 0.56 }

export default function CinPhone() {
  return (
    <div className='cin-full'>
      <div
        className='cin-split cin-split--left'
        style={anim({
          at: [0.03, 0.12],
          out: [0.18, 0.23],
          x: -80,
          y: 0,
          ox: -80,
          oy: 0
        })}
      >
        Kein Test.
      </div>
      <div
        className='cin-split cin-split--right'
        style={anim({
          at: [0.07, 0.16],
          out: [0.18, 0.23],
          x: 80,
          y: 0,
          ox: 80,
          oy: 0
        })}
      >
        Ein Spiel.
      </div>

      {CAPTIONS.map((c) => (
        <div
          key={c.text}
          className={`cin-caption cin-caption--${c.side}`}
          style={anim({ at: c.at, out: c.out, y: 40, oy: -40 })}
        >
          <div className='cin-eyebrow cin-eyebrow--light'>{c.eyebrow}</div>
          <div className='cin-caption__text'>{c.text}</div>
        </div>
      ))}

      <Fit
        w={260}
        h={540}
        maxH={0.82}
        maxW={0.5}
        narrow={NARROW}
        className='cin-phone-fit'
      >
        <div
          className='cin-phone-3d'
          style={{
            ...prog([0, 0.2]),
            transform:
              'translateY(calc((1 - var(--p)) * 220px)) rotateX(calc((1 - var(--p)) * 58deg)) ' +
              'rotateZ(calc((1 - var(--p)) * -24deg)) scale(calc(0.72 + 0.28 * var(--p)))'
          }}
        >
          <Phone x={0} y={0}>
            <div
              className='sty-abs sty-screen'
              style={anim({ at: [-1, 0], out: [0.2, 0.23], y: 0, oy: -20 })}
            >
              <div className='sty-h4'>Hi Lena!</div>
              <div className='sty-muted sty-small sty-mt-1'>
                Entdecke deine Stärken mit drei kurzen Spielen.
              </div>
              <div className='sty-mt-4'>
                {GAMES.map((g, i) => (
                  <div
                    key={g.title}
                    className='sty-game-row'
                    style={anim({
                      at: stagger(0.08, 0.02, 0.05, i),
                      x: 20,
                      y: 0
                    })}
                  >
                    <Shape kind={g.kind} color={g.color} size={18} />
                    <span className='sty-grow'>{g.title}</span>
                    <span className='sty-muted sty-small'>{g.dim}</span>
                  </div>
                ))}
              </div>
              <div
                className='sty-btn sty-btn--full'
                style={anim({ at: [0.14, 0.18], s: 0.9, y: 10 })}
              >
                Los geht&apos;s
              </div>
            </div>

            <SubRange
              at={[0.23, 0.82]}
              className='sty-abs cin-inset'
              style={anim({
                at: [0.21, 0.24],
                out: [0.8, 0.83],
                y: 20,
                oy: -20
              })}
            >
              <GameScreens />
            </SubRange>

            <div
              className='sty-abs sty-screen'
              style={anim({ at: [0.82, 0.86], y: 20 })}
            >
              <div className='sty-feedback-head'>
                <div className='sty-h4 sty-center'>Dein Stärkenprofil</div>
              </div>
              {STRENGTHS.map((s, i) => (
                <div
                  key={s.title}
                  className='sty-strength'
                  style={anim({ at: stagger(0.85, 0.03, 0.06, i), y: 24 })}
                >
                  <Shape kind={s.shape} color={s.color} size={26} />
                  <div>
                    <div className='sty-strong'>{s.title}</div>
                    <div className='sty-muted sty-small'>{s.text}</div>
                  </div>
                </div>
              ))}
            </div>
          </Phone>
        </div>
      </Fit>
    </div>
  )
}
